import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "motion/react";
import { SlideUpLine, FadeUp, Stagger, StaggerItem } from "@/pages/_shared/anim";
import HomeElevators from "../../../assets/Home3.jpg"
import PassengerElevators from "../../../assets/Home4.jpg"
import CargoElevators from "../../../assets/Home5.jpg"
import BedElevators from "../../../assets/Home6.jpg"
import PanoramicElevators from "../../../assets/Home7.jpg"
import KitchenElevators from "../../../assets/Home8.jpg"
import { Link } from "react-router-dom";

const solutions = [
  {
    title: "Home Elevators",
    desc: "Vertical mobility solutions for homes and villas.",
    icon: "ri-home-4-line",
    image: HomeElevators
  },
  {
    title: "Passenger Elevators",
    desc: "Reliable people-moving solutions for residential and commercial buildings.",
    icon: "ri-building-2-line",
    image: PassengerElevators
  },
  {
    title: "Cargo Elevators",
    desc: "Heavy-duty solutions for transporting goods and materials.",
    icon: "ri-truck-line",
    image: CargoElevators
  },
  {
    title: "Bed Elevators",
    desc: "Spacious vertical transportation designed for hospitals and healthcare environments.",
    icon: "ri-hospital-line",
    image: BedElevators
  },
  {
    title: "Panoramic Elevators",
    desc: "Architectural elevator solutions combining mobility with visual design.",
    icon: "ri-eye-line",
    image: PanoramicElevators
  },
  {
    title: "Kitchen Elevators",
    desc: "Compact service elevators for food, supplies, and lightweight goods.",
    icon: "ri-restaurant-line",
    image: KitchenElevators
  },
];

export default function Projects() {
  const [paused, setPaused] = useState(false);
  const [activeSol, setActiveSol] = useState(0);

  useEffect(() => {
    if (paused) return;
    const id = setInterval(() => {
      setActiveSol((i) => (i + 1) % solutions.length);
    }, 4000);
    return () => clearInterval(id);
  }, [paused]);

  return (
    <section id="solutions" className="bg-crest-cream py-20 md:py-28" data-product-shop>
      <div className="px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-12">
          <div className="max-w-2xl">
            <FadeUp>
              <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-crest-deep/60 uppercase">
                <span className="w-6 h-px bg-crest-deep/40" /> Solutions we deliver
              </span>
            </FadeUp>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-crest-deep leading-tight mt-5">
              <SlideUpLine as="div">
                Built Around Different
              </SlideUpLine>
              <SlideUpLine as="div" delay={0.1}>
                <em className="not-italic text-crest-bg">Vertical Mobility</em> Needs.
              </SlideUpLine>
            </h2>
          </div>
          {/* <FadeUp delay={0.2}>
            <div
              className="flex flex-wrap gap-2 p-1 bg-white rounded-full border border-black/5 self-start md:self-end relative"
              onMouseEnter={() => setPaused(true)}
              onMouseLeave={() => setPaused(false)}
            >
              {solutions.map((s, i) => (
                <button
                  key={s.title}
                  onClick={() => {
                    setActiveSol(i);
                    setPaused(true);
                  }}
                  className={`relative px-4 py-2 rounded-full text-xs md:text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    i === activeSol
                      ? "text-white"
                      : "text-crest-deep/70 hover:text-crest-deep"
                  }`}
                >
                  {i === activeSol && (
                    <motion.span
                      layoutId="sol-pill"
                      className="absolute inset-0 bg-crest-deep rounded-full"
                      transition={{ type: "spring", stiffness: 380, damping: 32 }}
                    />
                  )}
                  <span className="relative z-10">{s.title}</span>
                </button>
              ))}
            </div>
          </FadeUp> */}
        </div>

        <Stagger
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5"
          stagger={0.08}
        >
          <AnimatePresence mode="popLayout">
            {solutions.map((s, i) => (
              <motion.article
                key={s.title}
                layout
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20, scale: 0.96 }}
                transition={{ duration: 0.5, ease: [0.25, 0.1, 0.25, 1] }}
                className={`group relative rounded-lg overflow-hidden cursor-pointer ${
                   i === 0 || i === 5 ? "lg:col-span-2" : i === 4 ? "lg:row-span-2" : ""
                }`}
                data-product-shop
              >
                <div
                    className={`w-full transition-transform duration-700 group-hover:scale-105 ${
                    i === 4
                      ? "h-[360px] md:h-[420px] lg:h-full"
                      : "h-[360px] md:h-[420px]"
                  }`}
                  style={{
                    backgroundImage: `url(${s.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-crest-deep/85 via-crest-deep/10 to-transparent" />
                <div className="absolute top-4 left-4 flex items-center gap-2">
                  <span className="w-10 h-10 flex items-center justify-center rounded-md bg-crest-orange text-white">
                    <i className={`${s.icon} text-lg`}></i>
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6 flex items-end justify-between gap-4">
                  <div>
                    <h3 className="font-display text-2xl md:text-3xl text-white leading-tight">
                      {s.title}
                    </h3>
                    <p className="text-white/80 text-sm leading-relaxed mt-2">
                      {s.desc}
                    </p>
                  </div>
                  <span className="shrink-0 w-11 h-11 flex items-center justify-center rounded-full bg-crest-orange text-white group-hover:rotate-45 transition-transform duration-300">
                    <i className="ri-arrow-right-up-line text-lg"></i>
                  </span>
                </div>
              </motion.article>
            ))}
          </AnimatePresence>
          <StaggerItem className="hidden" />
        </Stagger>

        <FadeUp delay={0.1} className="mt-12 flex justify-center">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 border border-crest-deep/30 text-crest-deep hover:bg-crest-deep hover:text-crest-orange hover:border-crest-deep transition-colors px-7 py-3.5 rounded-full text-sm font-medium cursor-pointer whitespace-nowrap"
          >
            DISCUSS YOUR ELEVATOR REQUIREMENT
            <i className="ri-arrow-right-up-line"></i>
          </Link>
        </FadeUp>
      </div>
    </section>
  );
}